{
  "id": "driftroot_lagoon_02",
  "name": "Driftroot Lagoon",
  "theme": "driftroot_lagoon",
  "targetSeconds": 60,
  "spawn": { "x": 64, "y": 640 },
  "finishX": 19200,
  "killY": 960,
  "waterY": 752,
  "segments": [
    { "type": "checkpoint", "x": 64, "y": 640 },
    {
      "type": "ground",
      "x": 0,
      "y": 640,
      "w": 896,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    { "type": "gap", "x": 896, "w": 96 },
    {
      "type": "ground",
      "x": 992,
      "y": 640,
      "w": 3168,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "shard_trail",
      "x": 768,
      "y": 560,
      "count": 7,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 64
    },
    { "type": "obstacle", "x": 1216, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    { "type": "item_box", "x": 1248, "y": 512 },
    { "type": "decor", "id": "mangrove_tree", "x": 320, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "root_arch", "x": 704, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "mangrove_tree", "x": 1120, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "mist_bank", "x": 1400, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "reeds", "x": 192, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "rope_coil", "x": 1024, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "shell_cluster", "x": 1504, "y": 640, "layer": "fg" },
    {
      "type": "platform",
      "x": 1728,
      "y": 576,
      "w": 64,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 1920,
      "y": 512,
      "w": 64,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 2112,
      "y": 448,
      "w": 64,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 2240,
      "y": 448,
      "w": 1344,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 3584,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "down",
      "style": "boardwalk",
      "supports": "auto"
    },
    { "type": "speed_strip", "x": 2304, "y": 448, "w": 512 },
    { "type": "item_box", "x": 2496, "y": 384 },
    {
      "type": "shard_trail",
      "x": 2912,
      "y": 352,
      "count": 6,
      "spacing": 32,
      "shape": "grid",
      "rows": 3
    },
    { "type": "barrel_roll", "x": 3008, "y": 640, "w": 448, "periodTicks": 120, "phaseTicks": 0 },
    { "type": "slow_strip", "x": 2208, "y": 640, "w": 384 },
    { "type": "stake_barricade", "x": 2432, "y": 640, "w": 64 },
    { "type": "obstacle", "x": 2784, "y": 576, "w": 96, "h": 64, "kind": "barrel_row" },
    { "type": "obstacle", "x": 2976, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    { "type": "obstacle", "x": 3040, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    { "type": "obstacle", "x": 3040, "y": 512, "w": 64, "h": 64, "kind": "crate" },
    { "type": "item_box", "x": 1984, "y": 512 },
    { "type": "item_box", "x": 3008, "y": 448 },
    { "type": "decor", "id": "mangrove_roots", "x": 1800, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "giant_lily_far", "x": 2400, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "mangrove_tree", "x": 2900, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "root_arch", "x": 3500, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "reeds", "x": 2100, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "barrel_small", "x": 2700, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "rope_coil", "x": 3700, "y": 640, "layer": "fg" },
    { "type": "checkpoint", "x": 3840, "y": 640 },
    {
      "type": "ramp",
      "x": 3904,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "up",
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 4160,
      "y": 448,
      "w": 640,
      "h": 32,
      "style": "rope_bridge",
      "supports": "auto"
    },
    { "type": "speed_strip", "x": 4224, "y": 448, "w": 384 },
    { "type": "shard_trail", "x": 4192, "y": 400, "count": 9, "spacing": 64, "shape": "line" },
    { "type": "gap", "x": 4160, "w": 1280 },
    {
      "type": "shard_trail",
      "x": 4800,
      "y": 400,
      "count": 7,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 96
    },
    {
      "type": "platform",
      "x": 5024,
      "y": 448,
      "w": 512,
      "h": 32,
      "style": "rope_bridge",
      "supports": "auto"
    },
    { "type": "item_box", "x": 4416, "y": 384 },
    {
      "type": "ramp",
      "x": 5536,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "down",
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "moving_platform",
      "x": 4160,
      "y": 736,
      "w": 256,
      "h": 32,
      "dx": 64,
      "dy": 0,
      "periodTicks": 120,
      "style": "raft",
      "supports": "none"
    },
    {
      "type": "crumbling_platform",
      "x": 4544,
      "y": 736,
      "w": 160,
      "h": 32,
      "style": "raft",
      "supports": "none"
    },
    {
      "type": "moving_platform",
      "x": 4896,
      "y": 736,
      "w": 128,
      "h": 32,
      "dx": 0,
      "dy": 32,
      "periodTicks": 90,
      "style": "raft",
      "supports": "none"
    },
    {
      "type": "platform",
      "x": 5184,
      "y": 736,
      "w": 160,
      "h": 32,
      "style": "raft",
      "supports": "none"
    },
    { "type": "shard_trail", "x": 4192, "y": 688, "count": 8, "spacing": 64, "shape": "line" },
    { "type": "shard_trail", "x": 4928, "y": 688, "count": 6, "spacing": 64, "shape": "line" },
    { "type": "item_box", "x": 4800, "y": 616 },
    {
      "type": "ground",
      "x": 5440,
      "y": 640,
      "w": 4320,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    { "type": "obstacle", "x": 5600, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    { "type": "obstacle", "x": 5664, "y": 576, "w": 64, "h": 64, "kind": "crate" },
    { "type": "item_box", "x": 5824, "y": 512 },
    { "type": "spiked_stone", "x": 6016, "y": 640 },
    { "type": "checkpoint", "x": 6272, "y": 640 },
    { "type": "decor", "id": "mangrove_tree", "x": 4100, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "root_arch", "x": 4700, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "giant_lily_far", "x": 5200, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "mangrove_roots", "x": 5900, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "lily_pads", "x": 4400, "y": 752, "layer": "fg" },
    { "type": "decor", "id": "lily_pads", "x": 5100, "y": 752, "layer": "fg" },
    { "type": "decor", "id": "dragonfly", "x": 4900, "y": 560, "layer": "fg" },
    { "type": "decor", "id": "reeds", "x": 6150, "y": 640, "layer": "fg" },
    { "type": "barrel_roll", "x": 6720, "y": 640, "w": 512, "periodTicks": 105, "phaseTicks": 0 },
    { "type": "trapdoor", "x": 7616, "y": 640, "w": 96, "periodTicks": 75, "phaseTicks": 0 },
    { "type": "item_box", "x": 7424, "y": 512 },
    { "type": "stake_barricade", "x": 8064, "y": 640, "w": 64 },
    { "type": "barrel_roll", "x": 8320, "y": 640, "w": 512, "periodTicks": 105, "phaseTicks": 50 },
    { "type": "item_box", "x": 9344, "y": 512 },
    { "type": "shard_trail", "x": 6752, "y": 544, "count": 8, "spacing": 64, "shape": "line" },
    {
      "type": "shard_trail",
      "x": 7584,
      "y": 560,
      "count": 6,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 64
    },
    {
      "type": "ramp",
      "x": 6464,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "up",
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 6720,
      "y": 448,
      "w": 1024,
      "h": 32,
      "style": "log",
      "supports": "auto"
    },
    { "type": "speed_strip", "x": 6784, "y": 448, "w": 512 },
    {
      "type": "platform",
      "x": 7936,
      "y": 448,
      "w": 1024,
      "h": 32,
      "style": "log",
      "supports": "auto"
    },
    { "type": "speed_strip", "x": 8000, "y": 448, "w": 384 },
    {
      "type": "log_ram",
      "x": 8576,
      "y": 224,
      "lengthPx": 200,
      "amplitudeDeg": 60,
      "periodTicks": 54,
      "phaseTicks": 0
    },
    { "type": "item_box", "x": 7360, "y": 384 },
    { "type": "shard_trail", "x": 6752, "y": 400, "count": 16, "spacing": 64, "shape": "line" },
    {
      "type": "shard_trail",
      "x": 7712,
      "y": 400,
      "count": 7,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 96
    },
    {
      "type": "ramp",
      "x": 8960,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "down",
      "style": "boardwalk",
      "supports": "auto"
    },
    { "type": "checkpoint", "x": 9408, "y": 640 },
    { "type": "decor", "id": "mangrove_tree", "x": 6500, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "root_arch", "x": 7200, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "waterfall_roots", "x": 7800, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "root_arch", "x": 8300, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "mist_bank", "x": 9300, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "net_hung", "x": 6900, "y": 672, "layer": "fg" },
    { "type": "decor", "id": "barrel_small", "x": 7500, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "shell_cluster", "x": 8200, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "reeds", "x": 9400, "y": 640, "layer": "fg" },
    { "type": "gap", "x": 9760, "w": 192 },
    {
      "type": "platform",
      "x": 9888,
      "y": 736,
      "w": 64,
      "h": 32,
      "style": "raft",
      "supports": "none"
    },
    { "type": "bounce_pad", "x": 9888, "y": 736, "w": 64 },
    {
      "type": "shard_trail",
      "x": 9728,
      "y": 560,
      "count": 7,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 96
    },
    {
      "type": "ground",
      "x": 9952,
      "y": 640,
      "w": 10528,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    { "type": "stake_barricade", "x": 10240, "y": 640, "w": 64 },
    { "type": "slow_strip", "x": 10560, "y": 640, "w": 384 },
    { "type": "trapdoor", "x": 11264, "y": 640, "w": 96, "periodTicks": 75, "phaseTicks": 20 },
    { "type": "obstacle", "x": 11744, "y": 576, "w": 96, "h": 64, "kind": "log_pile" },
    { "type": "obstacle", "x": 12128, "y": 576, "w": 64, "h": 64, "kind": "rock" },
    { "type": "obstacle", "x": 12192, "y": 576, "w": 64, "h": 64, "kind": "rock" },
    { "type": "item_box", "x": 10400, "y": 512 },
    { "type": "item_box", "x": 12416, "y": 512 },
    {
      "type": "platform",
      "x": 9888,
      "y": 448,
      "w": 1728,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    { "type": "speed_strip", "x": 10304, "y": 448, "w": 512 },
    { "type": "spiked_stone", "x": 10560, "y": 448 },
    {
      "type": "platform",
      "x": 11840,
      "y": 448,
      "w": 576,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    { "type": "item_box", "x": 11968, "y": 384 },
    { "type": "item_box", "x": 10752, "y": 384 },
    { "type": "shard_trail", "x": 10080, "y": 400, "count": 10, "spacing": 64, "shape": "line" },
    {
      "type": "ramp",
      "x": 11584,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "up",
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 10912,
      "y": 320,
      "w": 608,
      "h": 32,
      "style": "log",
      "supports": "auto"
    },
    {
      "type": "shard_trail",
      "x": 10976,
      "y": 192,
      "count": 8,
      "spacing": 32,
      "shape": "grid",
      "rows": 4
    },
    { "type": "item_box", "x": 11232, "y": 256 },
    {
      "type": "platform",
      "x": 12480,
      "y": 512,
      "w": 64,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 12672,
      "y": 576,
      "w": 64,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    { "type": "decor", "id": "mangrove_tree", "x": 10500, "y": 752, "layer": "mid", "scale": 1.4 },
    { "type": "decor", "id": "root_arch", "x": 11300, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "giant_lily_far", "x": 12000, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "mangrove_roots", "x": 12700, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "lily_pads", "x": 9900, "y": 752, "layer": "fg" },
    { "type": "decor", "id": "reeds", "x": 10700, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "rope_coil", "x": 11500, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "shell_cluster", "x": 12300, "y": 640, "layer": "fg" },
    {
      "type": "ramp",
      "x": 13056,
      "y": 576,
      "w": 128,
      "h": 64,
      "dir": "up",
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 13184,
      "y": 576,
      "w": 256,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 13440,
      "y": 576,
      "w": 128,
      "h": 64,
      "dir": "down",
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 13824,
      "y": 576,
      "w": 128,
      "h": 64,
      "dir": "up",
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "platform",
      "x": 13952,
      "y": 576,
      "w": 256,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 14208,
      "y": 576,
      "w": 128,
      "h": 64,
      "dir": "down",
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "boulder_drop",
      "x": 13696,
      "y": 320,
      "w": 64,
      "h": 64,
      "dropPx": 256,
      "periodTicks": 120,
      "phaseTicks": 30
    },
    { "type": "item_box", "x": 14400, "y": 512 },
    { "type": "barrel_roll", "x": 14528, "y": 640, "w": 448, "periodTicks": 120, "phaseTicks": 0 },
    {
      "type": "shard_trail",
      "x": 13120,
      "y": 512,
      "count": 6,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 64
    },
    {
      "type": "platform",
      "x": 12896,
      "y": 576,
      "w": 128,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    { "type": "bounce_pad", "x": 12896, "y": 576, "w": 128 },
    {
      "type": "platform",
      "x": 13056,
      "y": 448,
      "w": 1984,
      "h": 32,
      "style": "rope_bridge",
      "supports": "auto"
    },
    { "type": "speed_strip", "x": 13184, "y": 448, "w": 512 },
    { "type": "speed_strip", "x": 14464, "y": 448, "w": 288 },
    {
      "type": "shard_trail",
      "x": 14080,
      "y": 352,
      "count": 8,
      "spacing": 32,
      "shape": "grid",
      "rows": 3
    },
    { "type": "item_box", "x": 13760, "y": 384 },
    { "type": "spiked_stone", "x": 13632, "y": 448 },
    {
      "type": "platform",
      "x": 15232,
      "y": 448,
      "w": 128,
      "h": 32,
      "style": "boardwalk",
      "supports": "auto"
    },
    {
      "type": "ramp",
      "x": 15360,
      "y": 448,
      "w": 256,
      "h": 128,
      "dir": "down",
      "style": "boardwalk",
      "supports": "auto"
    },
    { "type": "checkpoint", "x": 15744, "y": 640 },
    { "type": "speed_strip", "x": 16128, "y": 640, "w": 192 },
    { "type": "speed_strip", "x": 17216, "y": 640, "w": 192 },
    { "type": "speed_strip", "x": 18304, "y": 640, "w": 192 },
    { "type": "item_box", "x": 15936, "y": 512 },
    { "type": "item_box", "x": 16960, "y": 512 },
    { "type": "item_box", "x": 17984, "y": 512 },
    { "type": "shard_trail", "x": 16384, "y": 592, "count": 10, "spacing": 64, "shape": "line" },
    { "type": "shard_trail", "x": 17472, "y": 592, "count": 10, "spacing": 64, "shape": "line" },
    {
      "type": "shard_trail",
      "x": 18560,
      "y": 560,
      "count": 7,
      "spacing": 32,
      "shape": "arc",
      "arcHeight": 64
    },
    { "type": "decor", "id": "mangrove_tree", "x": 13300, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "root_arch", "x": 14200, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "root_arch", "x": 14900, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "giant_lily_far", "x": 15500, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "mist_bank", "x": 16500, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "lily_island", "x": 17600, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "finish_driftwood_arch", "x": 19200, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "mangrove_tree", "x": 19900, "y": 752, "layer": "mid" },
    { "type": "decor", "id": "lily_pads", "x": 16000, "y": 752, "layer": "fg" },
    { "type": "decor", "id": "lily_pads", "x": 18000, "y": 752, "layer": "fg" },
    { "type": "decor", "id": "flag_celebration", "x": 18900, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "flag_celebration", "x": 19300, "y": 640, "layer": "fg" },
    { "type": "decor", "id": "shell_cluster", "x": 19600, "y": 640, "layer": "fg" }
  ]
}
